import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { SsoService, TenantSPInformation } from 'api';
import { Logger } from 'utilities';

const useGetSPMetadata = (firmId: number | null) => {
  const [serviceProviderMetadata, setServiceProviderMetadata] = useState<TenantSPInformation | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const fetchServiceProviderMetadata = useCallback(
    async (firmId: number) => {
      try {
        const response = await SsoService.apiSsoTenantRead(firmId.toString());
        setServiceProviderMetadata(response);
      } catch (error) {
        Logger.error('Error fetching service provider metadata:', error);
        enqueueSnackbar('Failed to fetch service provider metadata.', { variant: 'error' });
        setServiceProviderMetadata(null);
      }
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    if (firmId !== null) {
      fetchServiceProviderMetadata(firmId);
    }
  }, [firmId, fetchServiceProviderMetadata]);

  return {
    serviceProviderMetadata,
  };
};

export default useGetSPMetadata;
